<div class="sidebar-container mb-4 ml-3 ml-md-5" *ngIf="step$ | async as step">
    <div class="d-inline d-wdgt-none">
        <div class="clearfix text-right">
            <button class="btn" (click)="closeModal()" type="button">
                <i class="icon icon-edponline-Bop-071 icon-2x" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <div class="sidebar-steps">
        <ng-container *ngFor="let stepNum of steps$ | async" class="step-oval">
            <div class="step-oval" [ngClass]="{'step-disabled': step !== stepNum}">
                <span class="step-oval-text">{{stepNum}}</span>
            </div>
        </ng-container>
    </div>
    <div class="sidebar-content">
        <div class="sidebar-content-header">
            <span class="sidebar-step-title" *ngIf="selfcare && step !== 1"
                [innerHTML]="'pt.edp.edponline.requests-and-operations.creation.side-bar.step2.faqs-and-selfcare' | translate"></span>
            <span class="sidebar-step-title" *ngIf="!selfcare || step === 1"
                [innerHTML]="('pt.edp.edponline.resquests-and-operations.creation.side-bar.step' + step) | translate"></span>
        </div>
        <div class="d-flex flex-column sidebar-content-footer" *ngIf="step > 1">
            <span class="title">{{ 'pt.edp.edponline.resquests-and-operations.step-motive' | translate }}</span>
            <span class="name">{{ motiveName }}</span>
        </div>
    </div>
    <div class="sidebar-footer d-none d-wdgt-block" *ngIf="step > 1 && step !== 3">
        <a (click)="backStep()" [gaClickDatalayer]="'requestsNewModalBack'">
            <span><i class="sidebar-footer-icon icon-edponline-Bop-073 rotate-90" aria-hidden="true"></i></span>
            <span class="ml-2 sidebar-footer-text">{{ 'pt.edp.edponline.resquests-and-operations.previous' | translate }}</span>
        </a>
    </div>
</div>